<template>
  <div id="adminSettinJS">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Javascript</router-link>
      </li>
    </ol>
    <div class="container" style="max-width:100%!important;max-height:100%!important;">
      <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
        <!-- ul tab -->
        <div class="row">
          <div class="col-sm-12">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item">
                <button
                  id="tabJsHead"
                  class="nav-links active"
                  type="button"
                  data-toggle="tab"
                  href="#tabJsHead"
                  role="tab"
                  aria-controls="tabJsHead"
                  v-on:click="ontabJsHead"
                >
                  <span>Js Head</span>
                </button>
              </li>
              <li class="nav-item">
                <button
                  id="tabJsBody"
                  class="nav-links"
                  type="button"
                  data-toggle="tab"
                  href="#tabJsBody"
                  role="tab"
                  aria-controls="tabJsBody"
                  v-on:click="ontabJsBody"
                >
                  <span>Js Body</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <!-- end ul tab -->
        <div class="tab-content" style="border: 0px solid #c8ced3;margin-top:0px;">
          <!-- tab js head -->
          <div class="card-body active tab-pane" id="jsHead">
            <div class="card">
              <div class="row">
                <div class="col">
                  <codemirror v-model="jsToSaveHead" :options="cmOptions"></codemirror>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelDataHead"
                  ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                  <button type="button" class="btn btn-success" @click="confirmSaveDataHead"><i class="fa fa-floppy-o"></i>&nbsp;Salva js Head</button>
                </div>
              </div>
            </div>
          </div>
          <!-- end tab js head -->
          <!-- tab js body -->
          <div class="card-body tab-pane" id="jsBody">
            <div class="card">
              <div class="row">
                <div class="col">
                  <codemirror v-model="cssToSave" :options="cmOptions"></codemirror>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelData"
                  ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                  <button type="button" class="btn btn-success" @click="confirmSaveData"><i class="fa fa-floppy-o"></i>&nbsp;Salva js Body</button>
                </div>
              </div>
            </div>
          </div>
          <!-- end tab js body -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";

 import 'codemirror/mode/javascript/javascript.js'
  // theme css
  import 'codemirror/theme/monokai.css'
  // require active-line.js
  import'codemirror/addon/selection/active-line.js'
  // styleSelectedText
  import'codemirror/addon/selection/mark-selection.js'
  import'codemirror/addon/search/searchcursor.js'

  // hint
  import'codemirror/addon/hint/show-hint.js'
   import'codemirror/addon/hint/javascript-hint.js'

  //import'codemirror/addon/hint/show-hint.css'
 
  // highlightSelectionMatches
  import'codemirror/addon/scroll/annotatescrollbar.js'
  import'codemirror/addon/search/matchesonscrollbar.js'
  import'codemirror/addon/search/match-highlighter.js'
  // keyMap
  import'codemirror/mode/clike/clike.js'
  import'codemirror/addon/edit/matchbrackets.js'
  import'codemirror/addon/comment/comment.js'
  import'codemirror/addon/dialog/dialog.js'
  import'codemirror/addon/dialog/dialog.css'
  import'codemirror/addon/search/search.js'
  import'codemirror/keymap/sublime.js'
  // foldGutter
  import'codemirror/addon/fold/foldgutter.css'
  import'codemirror/addon/fold/brace-fold.js'
  import'codemirror/addon/fold/comment-fold.js'
  import'codemirror/addon/fold/foldcode.js'
  import'codemirror/addon/fold/foldgutter.js'
  import'codemirror/addon/fold/indent-fold.js'
  import'codemirror/addon/fold/markdown-fold.js'
  import'codemirror/addon/fold/xml-fold.js'
  


export default {
  name: "adminSettinJS",
  components: {
    codemirror
  },
  data() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      confirmCancel: dictionaryHelpers.getDictionary("ConfirmCancel"),
      confirmSave: dictionaryHelpers.getDictionary("ConfirmSave"),
      /*cmOptions: {
        indentWithTabs: true,
        styleActiveLine: true,
        line: true,
        lineNumbers: true,
        lineWrapping: true,
        mode: "text/javascript",
        tabMode: "indent",
        theme:'default',
        tabSize: 4
      },*/
        cmOptions: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          styleSelectedText: false,
          line: true,
          foldGutter: true,
          gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
          highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
          mode: 'text/javascript',
          // hint.js options
          hintOptions:{
            completeSingle: false
          },

          keyMap: "sublime",
          matchBrackets: true,
          showCursorWhenSelecting: true,
          theme: "default",
          extraKeys: { "Ctrl": "autocomplete" }
        },
      cssToSave: "",
      jsToSaveHead: "",
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname
    };
  },


  created() {
    spinnerHelpers.show();
    this.loadCss();

    setTimeout(function() {
      var height =
        window.innerHeight -
        150 -
        $(".app-header").height() -
        $(".breadcrumb").height() -
        $(".app-footer").height();

      $(".vue-codemirror").height(height);
      $(".CodeMirror").height(height);
      $(".CodeMirror-gutters").css('z-index', '2');
      $(".CodeMirror-gutter-wrapper").css('z-index', '3');
    }, 100);
  },
  methods: {
    loadCss() {
      var adminSettinJS = this;

      jsServices.get(function(result) {
        adminSettinJS.cssToSave = result.data.jsBody;
        adminSettinJS.jsToSaveHead = result.data.jsHead;
        $("#jsHead").addClass("active");
        $("#jsBody").removeClass("active");

        spinnerHelpers.hide();
      });
    },
    ontabJsHead: function () {
        $("#jsHead").addClass("active");
        $("#jsBody").removeClass("active");
    },
    ontabJsBody: function () {
        $("#jsBody").addClass("active");
        $("#jsHead").removeClass("active");
    },
    confirmCancelData() {
      if (confirm(this.confirmCancel)) {
        this.executeCancelData();
      }
    },
    confirmCancelDataHead() {
      if (confirm(this.confirmCancel)) {
        this.executeCancelDataHead();
      }
    },

    executeCancelData() {
      spinnerHelpers.show();
      this.cssToSave = this.cssRead;
      spinnerHelpers.hide();
    },
    executeCancelDataHead() {
      spinnerHelpers.show();
      this.loadCss();
      spinnerHelpers.hide();
    },

    confirmSaveData() {
      if (confirm(this.confirmSave)) {
        this.executeSaveData();
      }
    },

    confirmSaveDataHead() {
      if (confirm(this.confirmSave)) {
        this.executeSaveDataHead();
      }
    },

    executeSaveData() {
      spinnerHelpers.show();
      var adminSettinJS = this;

      jsServices.update(this.cssToSave, function() {
        notificationHelpers.success(adminSettinJS.updateCompleted);
        adminSettinJS.loadCss();
      });
    },
    executeSaveDataHead() {
      spinnerHelpers.show();
      var adminSettinJS = this;

      jsServices.updateHead(this.jsToSaveHead, function() {
        notificationHelpers.success(adminSettinJS.updateCompleted);
        adminSettinJS.loadCss();
      });
    }
  }
};
</script>

<style>
.tab-content .tab-pane {
    padding: 0rem;
    border: 0px solid #c8ced3!important;
}
.nav-tabs .nav-links {
    width: 100%;
    border-radius: 0;
    color: #fff;
    background: #73818f;
    border-bottom: 3px solid #936c6c !important;
    border: 0px;
    height: 40px;
}

.nav-tabs .nav-links.active {
  background-color:#936c6c;
}

#adminSettinJS .CodeMirror-gutters, #adminSettinManageStyle .CodeMirror-gutters{
  z-index: 2 !important;
}
#adminSettinJS  .CodeMirror-gutter-wrapper, #adminSettinManageStyle .CodeMirror-gutters-wrapper{
  z-index:3 !important;
}
</style>
